import { render, staticRenderFns } from "./default.vue?vue&type=template&id=51abd4b4"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/app/components/AppHeader.vue').default,AppFooter: require('/app/components/AppFooter.vue').default,AppScrollToTop: require('/app/components/AppScrollToTop.vue').default,AppSnackBarMessages: require('/app/components/AppSnackBarMessages.vue').default})
